import { JobBoardFilters } from 'components/pages/jobBoard/JobBoardFilters';
import React from 'react';
import { useDispatch } from 'react-redux';

type RightPanelFiltersProps = {
  data: any;
};

const RightPanelFilters: React.FC<RightPanelFiltersProps> = ({
  children,
  data,
}) => {
  const dispatch = useDispatch();
  return <JobBoardFilters data={data} />;
};

export { RightPanelFilters };
